<template>
    <div class="modal fade" :id="id" aria-hidden="true" aria-labelledby="exampleGrid" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-simple modal-center">
        <div class="modal-content">
          <form autocomplete="off">
            <div class="modal-header">
              <div class="container">
                <div class="row header">
                  <div class="col-8">
                    <h4 class="modal-title">{{$t('booking.detail.invoices.send_invoice_modal.title')}}</h4>
                  </div>
                  <div class="col-4">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="close('#' + id)">
                      <span aria-hidden="true" class="close-btn">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-body">

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group form-material">
                    <label class="control-label" for="send-invoice-email">{{ $t("input.email") }}</label>
                    <input type="email" class="form-control" id="send-invoice-email" v-model="invoice.email.email" required/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group form-material">
                    <label class="control-label" for="send-invoice-subject">{{ $t("input.subject") }}</label>
                    <input type="text" class="form-control" id="send-invoice-subject" v-model="invoice.email.subject" required/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group form-material">
                    <label class="control-label" for="message">{{ $t("input.message") }}</label>
                    <textarea id="message" class="form-control" name="message" rows="5" v-model="invoice.email.message" required></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer text-center">
              <v-loading :isLoading="loading" :height="50" :width="50" :viewbox="'0 0 50 50'" :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>
              <button :disabled="loading" type="button" class="btn waves-effect waves-classic btn-cancel" @click.prevent="close()"
                      data-dismiss="modal">{{ $t("button.cancel") }}
              </button>
              <button :disabled="loading" type="button" class="btn btn-primary waves-effect waves-classic btn-save" @click.prevent="send">{{$t("button.send")}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
import mixin from "../../../mixins/mixin";
import superconciergerie from '../../../services/superconciergerie';
export default {
  data() {
    return {
        loading: true,
        ownerId: '',
        month: '',
        year: '',
        email: '',
        subject: '',
        type: 'detailed',
        detailedInvoicePermalink: '',
        globalInvoicePermalink: '',
        invoice: {
            email: {
                email: '',
                subject: '',
                message: ''
            }
        },
        rentalOwner: {},
        user: {},
    }
  },
  mixins: [mixin],
  methods: {
    open(ownerId, month, year, type = 'detailed') {
        this.ownerId = ownerId;
        this.month = month;
        this.year = year;
        this.type = type;
        this.openModal('#' + this.id);
    },
    close() {
        this.invoice.email.email = '';
        this.invoice.email.subject = '';
        this.invoice.email.message = '';
        this.type = 'detailed';
        this.permalink = '';
        this.ownerId = '';
        this.month = '';
        this.year = '';
        this.closeModal('#' + this.id);
    },
    async send() {
        this.loading = true;
        await superconciergerie.sendInvoice(this.invoice.permalink, this.invoice.email.email, this.invoice.email.subject, this.invoice.email.message, this);
        this.loading = false;
    },
    async fetchInfo() {
        this.loading = true;
        if(this.ownerId != '' && this.month != '' && this.year != '' && this.type != '' ) {
            await superconciergerie.getInvoice(this.ownerId, this.month, this.year, this);
        }
        this.loading = false;
    }
  },
  async mounted() {
    await this.fetchInfo();
  },
  props: ['id'],
  watch: {
    ownerId: async function (val) {
        await this.fetchInfo();
    },
    month: async function (val) {
        await this.fetchInfo();
    },
    year: async function (val) {
        await this.fetchInfo();
    },
    type: async function (val) {
        await this.fetchInfo();
    }
  },
}
</script>



// WEBPACK FOOTER //
// sendInvoiceModal.vue?1b92a9f6